export const SET_LOADING = 'src/store/salesReport/SET_LOADING'
export const SET_DOWNLOAD_LOADING = 'src/store/salesReport/SET_DOWNLOAD_LOADING'
export const SET_TRANSACTION = 'src/store/salesReport/SET_TRANSACTION'
export const SET_COUNT = 'src/store/salesReport/SET_COUNT'
export const SET_STATISTIC = 'src/store/salesReport/SET_STATISTIC'
export const SET_MATCH = 'src/store/salesReport/SET_MATCH'
export const SET_STADIUM = 'src/store/salesReport/SET_STADIUM'
export const SET_DOWNLOAD_RESPONSE = 'src/store/salesReport/SET_DOWNLOAD_RESPONSE'

